import {Visibility} from "@mui/icons-material";
import {IconButton, Typography} from "@mui/material";
import { useEffect, useState} from "react";
import {ResponsiveRow} from "../../../constants/layout.constants";
import ViewReminderModal from "../../modals/dashboard/buildingDirector/viewReminderModal";
import {getReminders} from "../../../services/dashboard.service";
import MuiDataGrid from "../MuiDataGrid";
import {useSelector} from "react-redux";
import CreateRSRInvoiceModal from "../../modals/accounting/invoice/createRSRInvoiceModal";
import { updateRSR as completeRSR, viewRSR } from "../../../services/lease.service";
import { issueResponseMessage, issueWarnMessage } from "../../../actions/message";

/**
 *
 * REQUIRED PROPS
 *
 * customWidth: string
 * customHeight: string
 * data: [{
 *    id: number
      type: string
      date: string
      description: string
 *  }]
 */

export default function Reminders({customHeight, customWidth}) {
    const [DataGridRows, setDataGridRows] = useState([]);
    const [selectedNotification, setSelectedNotification] = useState();
    const [viewNotificationModal, setViewNotificationModal] = useState(false);
    const [generateInvoiceModal, setGenerateInvoiceModal] = useState(false);
    const [task, setTask] = useState("");
    const [bulkFileProgress] = useState(0);
    const [loading, setLoading] = useState(true);
    const user = useSelector((state) => state.auth.user);

    function handleViewOpenModal(data) {
        setSelectedNotification(data);
        setViewNotificationModal(true);
    }

    function handleViewCloseModal() {
        setViewNotificationModal(false);
    }

    async function handleGenerateInvoice() {
        if (selectedNotification?.isCompleted === false && !selectedNotification?.isInvoiced) {
            setTask("Create");
        }

        if (selectedNotification?.isCompleted === true && !selectedNotification?.isInvoiced) {
            setTask("Update");
        }

        setLoading(true);
        try {
            const data = await viewRSR(selectedNotification?.id);
            setSelectedNotification((prev) => ({ ...prev, ...data }));
        } catch (error) {
            console.error("Error fetching RSR data", error);
        } finally {
            setLoading(false);
        }

        setGenerateInvoiceModal(true);
        setViewNotificationModal(false);
    }

    function handleSaveRSRInvoice(chargeItems) {
        if (chargeItems.some((chargeItem) => chargeItem?.chargeCode === "REN" && !chargeItem?.revenueForThePeriod)) {
            issueWarnMessage("A revenue for the period is required for all Rent charge items");
            return;
        }
        setGenerateInvoiceModal(false);
        const data = {
            rsrId: selectedNotification?.id,
            // revenueForThePeriod: revenueForThePeriod,
            rsrChargeItems: chargeItems
        }

        setLoading(true);
        completeRSR(data, selectedNotification?.id)
            .then((res) => {
                setGenerateInvoiceModal(false);
                setViewNotificationModal(false);
                issueResponseMessage(res);
                window.location.reload();
                // return getReminders();
            })
            .then((response) => {
                if (response && response.data) {
                    setDataGridRows(response.data);
                }
            })
            .catch((err) => {
                console.error("Error updating RSR or fetching reminders", err);
            })
            .finally(() => {
                setLoading(false);
            });
    }

    // close RSR invoice modal
    function handleCancelClicked() {
        setGenerateInvoiceModal(false);
        setViewNotificationModal(false);
    }

    const DataGridColumns = [
        {
            field: "date",
            headerName: "Date",
            minWidth: 150,
            flex: 1.5,
            editable: true,
        },
        {
            field: "description",
            headerName: "Description",
            minWidth: 250,
            flex: 2.5,
            editable: true,
        },
        {
            field: "type",
            headerName: "Type",
            minWidth: 150,
            flex: 1.5,
        },
        {
            field: "action",
            headerName: "Action",
            sortable: false,
            width: 100,
            renderCell: (params) => (
                <ResponsiveRow
                    sx={{width: "100%", flexDirection: "row", flexWrap: "nowrap"}}
                >
                    <IconButton onClick={() => handleViewOpenModal(params.row)}>
                        <Visibility sx={{color: "#037171"}}/>
                    </IconButton>
                </ResponsiveRow>
            ),
        },
    ];

    useEffect(() => {
        setLoading(true);
        getReminders()
            .then((response) => {
                if (response && response.data) {
                    setDataGridRows(response.data);
                }
            })
            .finally(() => {
                setLoading(false);
            });
        return () => setDataGridRows([]);
    }, [user.proxyFacility]);

    return (
        <ResponsiveRow
            sx={{
                flexDirection: "column",
                flexWrap: "nowrap",

                alignItems: "flex-start",

                padding: "20px",

                height: {xs: "100%", lg: customHeight},
                minWidth: {xs: "100%", lg: customWidth},
                width: "100%",

                margin: "10px",

                backgroundColor: "#fff",
                borderRadius: "20px",
            }}
        >
            <Typography
                sx={{
                    width: "100%",
                }}
                textAlign="start"
                variant="h5"
            >
                Organization Reminders
            </Typography>


            <MuiDataGrid
                alt={true}
                noSelection={true}
                dataGridColumns={DataGridColumns}
                dataGridRows={DataGridRows}
                serverPagination={false}
                loading={loading}
                height="90%"
                totalRows={DataGridRows.length}
            />

            {viewNotificationModal && (
                <ViewReminderModal
                    handleClose={handleViewCloseModal}
                    open={viewNotificationModal}
                    notificationData={selectedNotification}
                    handleGenerateInvoice={handleGenerateInvoice}
                />
            )}

            {generateInvoiceModal && (
                <CreateRSRInvoiceModal
                    handleCancelClicked={handleCancelClicked}
                    task={task}
                    showAddInvoiceForm={generateInvoiceModal}
                    saveInvoiceClicked={handleSaveRSRInvoice}
                    rsr={selectedNotification}
                    bulkFileProgress={bulkFileProgress}
                />
            )}
        </ResponsiveRow>
    );
}
